module.exports = __webpack_public_path__ + "static/works_05-04dd74e2ca4187e1a32e1a822cda87f0.png";